/**
 * 应用根
 * - 根据 token 状态决定显示 welcome 还是主界面
 */

import { useEffect } from 'react';
import { Routes, Route, Navigate, useLocation } from 'react-router-dom';
import { Welcome } from './pages/Welcome';
import { Home } from './pages/Home';
import { Settings } from './pages/Settings';
import { useAuthStore } from './store/auth';
import { ToastViewport } from './components/Toast';
import { AddToHomeBanner } from './components/AddToHomeBanner';
import { ReminderDialog } from './components/ReminderDialog';

function ProtectedRoute({ children }: { children: JSX.Element }) {
  const token = useAuthStore((s) => s.token);
  const location = useLocation();
  if (!token) {
    return <Navigate to="/welcome" state={{ from: location }} replace />;
  }
  return children;
}

function App() {
  // 401/403 自动清空后, 跳转到 welcome
  const token = useAuthStore((s) => s.token);
  const location = useLocation();
  useEffect(() => {
    if (!token && location.pathname !== '/welcome') {
      // 路由由 ProtectedRoute 处理, 这里只用于侧边栏清理
    }
  }, [token, location.pathname]);

  return <AppShell />;
}

function AppShell() {
  return (
    <>
      <Routes>
        <Route path="/welcome" element={<Welcome />} />
        <Route
          path="/"
          element={
            <ProtectedRoute>
              <Home />
            </ProtectedRoute>
          }
        />
        <Route
          path="/settings"
          element={
            <ProtectedRoute>
              <Settings />
            </ProtectedRoute>
          }
        />
        <Route path="*" element={<Navigate to="/" replace />} />
      </Routes>
      <ToastViewport />
      <AddToHomeBanner />
      <ReminderDialog />
    </>
  );
}

export default App;